import axios from '../axios.jsx';
import { useEffect, useState, useMemo } from 'react';
import ReactPaginate from 'react-paginate';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Button, Modal, Badge } from 'react-bootstrap';
import Select from 'react-select/creatable';
import { useAuth } from '../AuthContext';
import "../styles/btn.css";

/* ─── Constantes ─── */
const URI_CIT  = 'citar_sar/';
const URI_AGE  = 'agenda/';
const URI4     = 'sendmailSAR/';
const BLOGS_PER_PAGE = 10;

const esEmailValido = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const LUGAR_OPTIONS = [
  { value: 'OFICINA VIGILANCIA EN SALUD PUBLICA',        label: 'OFICINA VIGILANCIA EN SALUD PUBLICA' },
  { value: 'MALOKA - SECRETARIA DE SALUD DEPARTAMENTAL', label: 'MALOKA - SECRETARIA DE SALUD DEPARTAMENTAL' },
  { value: 'OFICINA PAI DEPARTAMENTAL',                  label: 'OFICINA PAI DEPARTAMENTAL' },
];

/* ═══════════════════════════════════════════════════════════════════ */
const CompShowalertas = () => {

  /* ── Estado: datos ── */
  const [sats, setSats]             = useState([]);
  const [sars, setSars]             = useState([]);   // SARS (una fila por código)
  const [saras, setSaras]           = useState([]);   // SARA — Salud Ambiental (una fila por código)
  const [eris, setEris]             = useState([]); // registros de ERI activados
  const [cierresSat, setCierresSat] = useState([]);
  const [correos, setCorreos]       = useState([]);

  /* ── Estado: UI / navegación ── */
  const navigate                        = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const filter     = searchParams.get('filter');
  const [busqueda, setBusqueda]         = useState('');
  const [anioResumen, setAnioResumen]   = useState(new Date().getFullYear()); // inicia en el año en curso
  // Filtro elegido desde el resumen: { tipo: 'SAT'|'SEN', estado: null|'abiertas'|'cerradas' }
  const [filtroResumen, setFiltroResumen] = useState(null);
  const pageNumber = parseInt(searchParams.get('page') || '0', 10);

  /* ── Estado: usuario ── */
  const { user } = useAuth();
  const [name, setName]           = useState('');
  const [usernivel, setUsernivel] = useState('');

  /* ── Estado: modales ── */
  const [showChooser,      setShowChooser]      = useState(false);
  const [showChoosertabla, setShowChoosertabla] = useState(false);
  const [showSarModal,     setShowSarModal]     = useState(false);

  /* ── Estado: formulario SAR / SARA independiente ── */
  const [sarTipo,           setSarTipo]           = useState('SARS'); // 'SARS' | 'SARA'
  const [sarCodigo,         setSarCodigo]         = useState('');
  const [sarTitulo,         setSarTitulo]         = useState('');
  const [fechaCita,         setFechaCita]         = useState('');
  const [horaCita,          setHoraCita]          = useState('');
  const [horaCitafin,       setHoraCitafin]       = useState('');
  const [correoConsecutivo, setCorreoConsecutivo] = useState('');
  const [participantesCita, setParticipantesCita] = useState([]);
  const [tema,              setTema]              = useState('');
  const [lugar,             setlugar]             = useState(null);

  /* ─────────────────────────── Carga inicial ─────────────────────── */
  useEffect(() => {
    const username = sessionStorage.getItem('username');
    const nivel    = sessionStorage.getItem('usernivel');
    if (username) setName(username);
    if (nivel)    setUsernivel(nivel);

    getBlogs();
    getCierres();
    getSars();
    getEris();
    axios.get('/directorio').then(res =>
      setCorreos(res.data.map(c => ({ value: c.Correo, label: c.Correo })))
    );
  }, []);

  /* ─────────────────────────── Fetch data ────────────────────────── */
  const getBlogs = async () => {
    try {
      const res = await axios.get('/sat');
      setSats(res.data.reverse());
    } catch (err) { console.error(err); }
  };

  const getCierres = async () => {
    try {
      const res = await axios.get('/cierre');
      setCierresSat(res.data.map(r => r.Codigo));
    } catch (err) { console.error(err); }
  };

  // Trae todas las citaciones (SARS y SARA). Como una sala puede volver a
  // citarse, se deja UNA fila por código (la primera citación) y se cuenta
  // cuántas citaciones lleva.
  const getSars = async () => {
    try {
      const res = await axios.get('/citar_sar');
      const agrupar = (tipo) => {
        const porCodigo = new Map();
        (res.data || [])
          .filter(item => (item.Tipo_Sala || 'SARS') === tipo)
          .forEach(item => {
            const codigo = item.Codigo_SAT || item.Codigo || item.Codigo_SAR;
            const previo = porCodigo.get(codigo);
            if (previo) { previo.citaciones += 1; return; }
            porCodigo.set(codigo, {
              id:         item.id_sar || item.id,
              Codigo:     codigo,
              Gestor:     item.Gestor || item.Responsable,
              Titulo:     item.Titulo || item.Tema || '',
              Tipo_Sala:  tipo,
              citaciones: 1,
              isSar:      true,
            });
          });
        return [...porCodigo.values()].reverse();
      };
      setSars(agrupar('SARS'));
      setSaras(agrupar('SARA'));
    } catch (err) { console.error(err); }
  };

  // Trae los registros de ERI activados, para poder marcarlos en la tabla
  const getEris = async () => {
    try {
      const res = await axios.get('/activarEri');
      setEris(res.data || []);
    } catch (err) { console.error(err); }
  };

  /* ─────────────────────────── Filtrado y paginación ─────────────── */
  // Año de un registro: fecha de identificación; si no hay, el año del código (SAT0012026 -> 2026)
  const anioDe = (s) => {
    const f = s.Fecha_identificacion || s.createdAt;
    const y = f ? parseInt(String(f).slice(0, 4), 10) : NaN;
    if (!Number.isNaN(y)) return y;
    const m = String(s.Codigo || '').match(/(\d{4})$/);
    return m ? parseInt(m[1], 10) : null;
  };

  const filtered = useMemo(() => {
    let base = filtrarPorTipo();
    // Filtro desde el resumen: año del resumen + estado (abiertas / cerradas)
    if (filtroResumen) {
      if (anioResumen !== 'todos') base = base.filter(s => anioDe(s) === anioResumen);
      if (filtroResumen.estado === 'abiertas') base = base.filter(s => !cierresSat.includes(s.Codigo));
      if (filtroResumen.estado === 'cerradas') base = base.filter(s => cierresSat.includes(s.Codigo));
    }
    const q = busqueda.trim().toLowerCase();
    if (!q) return base;
    return base.filter(i =>
      [i.Codigo, i.Titulo, i.Gestor, i.Municipio, i.Evento]
        .some(v => String(v ?? '').toLowerCase().includes(q))
    );

    function filtrarPorTipo() {
    switch (filter) {
      case 'SAR':  return sars.filter(i => i.Codigo?.startsWith('SAR') && !i.Codigo?.startsWith('SARA'));
      case 'SARA': return saras.filter(i => i.Codigo?.startsWith('SARA'));
      case 'SEN':
      case 'SAT': return sats.filter(i => i.Codigo?.startsWith(filter));
      default:    return sats;
    }
    }
  }, [sats, sars, saras, filter, busqueda, filtroResumen, anioResumen, cierresSat]);


  // Años con registros (más el año en curso), del más reciente al más antiguo
  const aniosDisponibles = useMemo(() => {
    const set = new Set([new Date().getFullYear()]);
    sats.forEach(s => { const y = anioDe(s); if (y) set.add(y); });
    return [...set].sort((a, b) => b - a);
  }, [sats]);

  // Resumen del año elegido, separado por alertas y señales, abiertas y cerradas
  const resumen = useMemo(() => {
    const delAnio = anioResumen === 'todos' ? sats : sats.filter(s => anioDe(s) === anioResumen);
    const contar = (prefijo) => {
      const lista    = delAnio.filter(s => s.Codigo?.startsWith(prefijo));
      const cerradas = lista.filter(s => cierresSat.includes(s.Codigo)).length;
      return { total: lista.length, abiertas: lista.length - cerradas, cerradas };
    };
    return { SAT: contar('SAT'), SEN: contar('SEN') };
  }, [sats, cierresSat, anioResumen]);

  const cambiarFiltro = (f) => {
    setFiltroResumen(null);
    setSearchParams(f ? { filter: f, page: '0' } : { page: '0' });
  };

  // Clic en un número del resumen: filtra la tabla. Un segundo clic lo quita.
  const filtrarDesdeResumen = (tipo, estado) => {
    const mismo = filtroResumen && filtroResumen.tipo === tipo && filtroResumen.estado === estado;
    if (mismo) {
      setFiltroResumen(null);
      setSearchParams({ page: '0' });
      return;
    }
    setFiltroResumen({ tipo, estado });
    setSearchParams({ filter: tipo, page: '0' });
  };

  const descripcionFiltroResumen = filtroResumen
    ? `${filtroResumen.tipo === 'SAT' ? 'Alertas' : 'Señales'}${filtroResumen.estado ? ` ${filtroResumen.estado}` : ''} ${anioResumen === 'todos' ? 'de todos los años' : `de ${anioResumen}`}`
    : '';
  const onBuscar = (valor) => {
    setBusqueda(valor);
    setSearchParams(filter ? { filter, page: '0' } : { page: '0' }, { replace: true });
  };

  // Códigos que ya tienen una SARS activada -> n° de citaciones
  const sarsActivosMap = useMemo(
    () => new Map(sars.map(s => [s.Codigo, s.citaciones])),
    [sars]
  );

  // Códigos que ya tienen una SARA (Salud Ambiental) activada -> n° de citaciones
  const sarasActivosMap = useMemo(
    () => new Map(saras.map(s => [s.Codigo, s.citaciones])),
    [saras]
  );

  // Set de códigos que ya tienen un ERI activado
  const erisActivosSet = useMemo(
    () => new Set(eris.map(e => e.Codigo).filter(Boolean)),
    [eris]
  );

  const pageCount        = Math.ceil(filtered.length / BLOGS_PER_PAGE);
  const handlePageChange = ({ selected }) =>
    setSearchParams(filter ? { filter, page: String(selected) } : { page: String(selected) }, { replace: true });

  /* ─────────────────────────── Acciones CRUD ─────────────────────── */
  const handleEdit = id => {
    if (usernivel === '1') navigate(`/edit/${id}`);
    else Swal.fire({ icon: 'warning', title: 'Solo administradores' });
  };

  const handleDeleteBlog = async blog => {
    if (usernivel !== '1')
      return Swal.fire({ icon: 'warning', title: 'Solo administradores', text: 'No puedes eliminar.' });

    const result = await Swal.fire({
      title: '¿Eliminar registro?',
      icon: 'warning',
      showCancelButton:   true,
      confirmButtonText:  'Sí',
      cancelButtonText:   'No',
      confirmButtonColor: '#d33',
    });
    if (!result.isConfirmed) return;

    try {
      if (blog.isSar) {
        // Sala independiente (SARS-I / SARA-I): se borran TODAS sus citaciones
        await axios.delete(`citar_sar/codigo/${blog.Codigo}`);
        await axios.delete(`agenda/codigo/${blog.Codigo}`);
        await axios.delete(`reunion/codigo/${blog.Codigo}`);
        getSars();
      } else {
        await axios.delete(`sat/${blog.id}`);
        await axios.delete(`actualizacion/codigo/${blog.Codigo}`);
        await axios.delete(`citar_sar/codigo/${blog.Codigo}`);
        await axios.delete(`resultadoeri/codigo/${blog.Codigo}`);
        await axios.delete(`activarEri/codigo/${blog.Codigo}`);
        await axios.delete(`cierre/codigo/${blog.Codigo}`);
        await axios.delete(`agenda/codigo/${blog.Codigo}`);
        await axios.delete(`reunion/codigo/${blog.Codigo}`);
        getBlogs();
        getEris();
      }
      Swal.fire({ icon: 'success', title: 'Eliminado', timer: 1500 });
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: 'error', title: 'Error al eliminar.' });
    }
  };

  const handleCerrar = async blog => {
    // Si el registro ya fue cerrado antes, se entra directo a verlo (sin repetir las validaciones de cierre)
    if (cierresSat.includes(blog)) {
      return navigate(`/cierre/${blog}`);
    }

    try {
      const { data: citarSar }      = await axios.get('/citar_sar');
      const { data: activareri }    = await axios.get('/activarEri');
      const { data: reuniones }     = await axios.get('/reunion');
      const { data: conclusioneri } = await axios.get('/resultadoeri');

      const existeERI          = activareri.some(i    => i.Codigo     === blog);
      const conclusionesERI    = conclusioneri.filter(i => i.Codigo     === blog);
      const tieneConclusionERI = conclusionesERI.length > 0;

      // Hay conclusión(es) ERI registrada(s), pero alguna no tiene el documento Sitrep cargado
      const faltaSitrepERI = tieneConclusionERI && conclusionesERI.some(r => !r.Documento_Sitrep);

      // SARS y SARA: cada citación (incluidas las re-citaciones) debe tener
      // su conclusión y esa conclusión su listado de asistencia en PDF.
      const validarSala = (tipo) => {
        const citas = citarSar.filter(i => i.Codigo_SAT === blog && (i.Tipo_Sala || 'SARS') === tipo);
        if (!citas.length) return null;
        const reunionesSala = reuniones.filter(r => r.Codigo_SAT === blog && (r.Tipo_Sala || 'SARS') === tipo);
        for (let n = 0; n < citas.length; n++) {
          const c = citas[n];
          const etiqueta = n === 0 ? 'la 1ª citación' : `la re-citación N° ${n + 1}`;
          // Datos anteriores a la re-citación pueden no tener Id_Cita: se aceptan para la 1ª citación
          const concl = reunionesSala.find(r => r.Id_Cita === c.id)
            || (n === 0 ? reunionesSala.find(r => !r.Id_Cita) : null);
          if (!concl)
            return `${etiqueta.charAt(0).toUpperCase() + etiqueta.slice(1)} de la ${tipo} no tiene conclusión registrada.`;
          if (!concl.Listado_Asistencia)
            return `La conclusión de ${etiqueta} de la ${tipo} no tiene cargado el listado de asistencia (PDF).`;
        }
        return null;
      };

      const existeSARS = citarSar.some(i => i.Codigo_SAT === blog && (i.Tipo_Sala || 'SARS') === 'SARS');
      const existeSARA = citarSar.some(i => i.Codigo_SAT === blog && i.Tipo_Sala === 'SARA');

      if (!existeSARS && !existeSARA && !existeERI)
        return navigate(`/cierre/${blog}`);

      for (const tipo of ['SARS', 'SARA']) {
        const problema = validarSala(tipo);
        if (problema)
          return Swal.fire({ icon: 'warning', title: 'Acción no permitida', text: problema });
      }

      if (existeERI && !tieneConclusionERI)
        return Swal.fire({ icon: 'warning', title: 'Acción no permitida', text: 'El ERI está activado pero no tiene conclusiones registradas.' });

      if (existeERI && faltaSitrepERI)
        return Swal.fire({ icon: 'warning', title: 'Acción no permitida', text: 'La conclusión del ERI no tiene cargado el documento Sitrep (PDF).' });

      navigate(`/cierre/${blog}`);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Ocurrió un problema al verificar la información.' });
    }
  };

  /* ─────────────────────────── Descargas ─────────────────────────── */
  const downloadBlob = async (url, defaultName) => {
    try {
      const response = await axios.get(url, { responseType: 'blob' });
      let fileName   = defaultName;
      const cd       = response.headers['content-disposition'];
      if (cd) {
        const m = /filename="?([^"]+)"?/.exec(cd);
        if (m?.[1]) fileName = m[1];
      }
      const link = document.createElement('a');
      link.href  = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (err) { console.error('Error descargando:', err); }
  };

  const handleDownload = codigo => downloadBlob(`CarpetaSAT?Codigo=${codigo}`, `reportes_${codigo}.zip`);
  const handletablaSAT = ()     => downloadBlob('exportSAT/codigo?codigo=SAT', 'Export_SAT.xlsx');
  const handletablaSEN = ()     => downloadBlob('exportSAT/codigo?codigo=SEN', 'Export_SEN.xlsx');
  const handletablaSAR = ()     => downloadBlob('exportSAT/codigo?codigo=SAR', 'Export_SARS.xlsx');
  const handletablaSARA = ()    => downloadBlob('exportSAT/codigo?codigo=SARA', 'Export_SARA.xlsx');

  /* ─────────────────────────── Modal SAR ─────────────────────────── */
  // tipo: 'SARS' -> SARS-I (SAR0012026) | 'SARA' -> SARA-I (SARA0012026)
  const openSarModal = async (tipo = 'SARS') => {
    try {
      const res = await axios.get(tipo === 'SARA' ? '/codigosar/sara' : '/codigosar');
      setSarTipo(tipo);
      setSarCodigo(res.data.nextCode || '');
      setShowSarModal(true);
    } catch {
      Swal.fire('Error', `No se generó el código ${tipo === 'SARA' ? 'SARA' : 'SAR'}.`, 'error');
    }
  };

  const handleCrearSar = async () => {
    if (!sarTitulo.trim())
      return Swal.fire('Atención', `Escribe el título de la ${sarTipo}-I. Es el que aparece en el asunto del correo.`, 'warning');
    if (!fechaCita || !horaCita || !horaCitafin)
      return Swal.fire('Atención', 'Completa todos los campos.', 'warning');

    Swal.fire({ title: 'Guardando información...', text: 'Por favor espera un momento', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

    try {
      const { data: nueva } = await axios.post(URI_CIT, {
        Tipo_Sala:   sarTipo,
        Codigo_SAT:  sarCodigo,
        Titulo:      sarTitulo.trim(),
        Fecha:       fechaCita,
        Hora_inicio: horaCita,
        Hora_fin:    horaCitafin,
        Consecutivo: correoConsecutivo,
        Citados:     participantesCita.join(', '),
        Tema:        tema,
        Gestor:      sessionStorage.getItem('username') || '',
        Lugar:       lugar?.value || '',
      });

      await axios.post(URI_AGE, {
        Codigo:      sarCodigo,
        Fecha:       fechaCita,
        Hora_inicio: horaCita,
        Hora_fin:    horaCitafin,
        Titulo:      sarTipo === 'SARA'
          ? `SALA DE ANÁLISIS DE RIESGO EN SALUD AMBIENTAL (SARA) ${sarCodigo}`
          : `SALA DE ANÁLISIS DE RIESGO EN SALUD (SARS) ${sarCodigo}`,
        Responsable: sessionStorage.getItem('username') || '',
        Id_Cita:     nueva?.id,
      });
      await axios.get(URI4, {
        params: { codigo: sarCodigo, id: nueva?.id, emails: participantesCita.join(', ') },
      });

      Swal.fire({ icon: 'success', title: 'Guardado exitoso', text: 'La información se ha guardado correctamente.', timer: 2000, showConfirmButton: false });

      setFechaCita('');
      setHoraCita('');
      setHoraCitafin('');
      setCorreoConsecutivo('');
      setParticipantesCita([]);
      setTema('');
      setSarTitulo('');
      setShowSarModal(false);
      setShowChooser(false);
      getSars();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error al guardar', text: 'Ocurrió un problema al guardar la información.' });
      console.error(err);
    }
  };

  const onElegirTipo = tipo => {
    setShowChooser(false);
    navigate(`/create?tipo=${tipo}`);
  };

  // Tipo de registro según el prefijo del código (define el color del chip)
  const tipoCodigo = (codigo = '') => {
    if (codigo.startsWith('SARA')) return { clase: 'sara', nombre: 'SARA-I' };
    if (codigo.startsWith('SAR'))  return { clase: 'sars', nombre: 'SARS-I' };
    if (codigo.startsWith('SEN'))  return { clase: 'sen',  nombre: 'Señal' };
    return { clase: 'sat', nombre: 'Alerta' };
  };

  // Botón de sala/ERI: lleno si está activa, contorno si no
  const SalaBtn = ({ activa, sigla, citas, ruta, icono, variante = '' }) => (
    <button
      type="button"
      className={`sala-btn ${variante} ${activa ? 'is-activa' : ''}`}
      onClick={() => navigate(ruta)}
      title={activa ? `Ver ${sigla}${citas > 1 ? ` (${citas} citaciones)` : ''}` : `Activar ${sigla}`}
    >
      <i className={icono}></i>
      <span>{sigla}</span>
      {citas > 1 && <b className="sala-count">{citas}</b>}
    </button>
  );

  const FILTROS = [
    { key: null,   label: 'Todos' },
    { key: 'SAT',  label: 'Alertas' },
    { key: 'SEN',  label: 'Señales' },
    { key: 'SAR',  label: 'SARS-I' },
    { key: 'SARA', label: 'SARA-I' },
  ];
  const esSalaIndependiente = filter === 'SAR' || filter === 'SARA';
  const pagina = filtered.slice(pageNumber * BLOGS_PER_PAGE, (pageNumber + 1) * BLOGS_PER_PAGE);
  const desde  = filtered.length ? pageNumber * BLOGS_PER_PAGE + 1 : 0;
  const hasta  = Math.min((pageNumber + 1) * BLOGS_PER_PAGE, filtered.length);

  /* ═══════════════════════════════════════════════════════════════════
     RENDER
  ═══════════════════════════════════════════════════════════════════ */
  return (
    <div className="alertas-page">
      <style>{`
        .alertas-page {
          --sat-cyan: #28b6ea;
          --sat-cyan-dark: #1a8fbd;
          --sat-navy: #1f3a5f;
          --sat-ink: #22303f;
          --sat-muted: #6b7a8c;
          --sat-line: #e3e9ef;
          --sat-bg: #f5f8fa;
          --sat-open: #d97706;
          --sat-closed: #15803d;
          --sat-sara: #2f7d4f;
          color: var(--sat-ink);
          padding: 1.25rem 1.5rem 2rem;
          font-variant-numeric: tabular-nums;
        }

        /* ── Encabezado ── */
        .ap-head {
          display: flex; flex-wrap: wrap; align-items: flex-end;
          justify-content: space-between; gap: 1rem; margin-bottom: 1.25rem;
        }
        .ap-head h2 {
          font-size: 1.45rem; font-weight: 700; color: var(--sat-navy);
          margin: 0; letter-spacing: -0.01em;
        }
        .ap-head .ap-sub { color: var(--sat-muted); font-size: .9rem; margin: .2rem 0 0; }
        .ap-head-actions { display: flex; gap: .5rem; flex-wrap: wrap; }

        .ap-btn {
          display: inline-flex; align-items: center; gap: .45rem;
          border-radius: 8px; padding: .5rem .9rem; font-size: .88rem; font-weight: 600;
          border: 1px solid var(--sat-line); background: #fff; color: var(--sat-ink);
          transition: background-color .15s, border-color .15s, color .15s;
        }
        .ap-btn:hover { border-color: var(--sat-cyan); color: var(--sat-cyan-dark); }
        .ap-btn.primary { background: var(--sat-cyan); border-color: var(--sat-cyan); color: #fff; }
        .ap-btn.primary:hover { background: var(--sat-cyan-dark); border-color: var(--sat-cyan-dark); color: #fff; }
        .ap-btn:focus-visible, .sala-btn:focus-visible, .ic-btn:focus-visible, .ap-seg button:focus-visible {
          outline: 2px solid var(--sat-cyan); outline-offset: 2px;
        }

        /* ── Franja de resumen ── */
        .ap-resumen-head {
          display: flex; align-items: center; justify-content: space-between; gap: .75rem;
          margin-bottom: .5rem; font-size: .88rem; font-weight: 600; color: var(--sat-muted);
        }
        .ap-anio {
          border: 1px solid var(--sat-line); border-radius: 8px; background-color: #fff;
          padding: .3rem 2rem .3rem .7rem; font-size: .88rem; font-weight: 600; color: var(--sat-ink);
          appearance: none; cursor: pointer;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%236b7a8c'/%3E%3C/svg%3E");
          background-repeat: no-repeat; background-position: right .7rem center;
        }
        .ap-anio:focus { outline: none; border-color: var(--sat-cyan); box-shadow: 0 0 0 3px rgba(40,182,234,.18); }
        .ap-resumen {
          display: grid; grid-template-columns: 1fr 1fr; gap: .75rem; margin-bottom: 1rem;
        }
        .rs-grupo {
          display: grid; grid-template-columns: 1.25fr 1fr 1fr;
          background: #fff; border: 1px solid var(--sat-line); border-radius: 12px; overflow: hidden;
          border-top: 3px solid var(--sat-cyan);
        }
        .rs-grupo.g-sen { border-top-color: #e0a030; }
        .rs-cell {
          display: flex; flex-direction: column; align-items: flex-start; gap: 2px;
          border: 0; border-left: 1px solid var(--sat-line); background: transparent;
          padding: .8rem 1.1rem; text-align: left; cursor: pointer; color: var(--sat-ink);
          transition: background-color .15s;
        }
        .rs-cell:first-child { border-left: 0; }
        .rs-cell:hover { background: #f4f9fc; }
        .rs-cell:focus-visible { outline: 2px solid var(--sat-cyan); outline-offset: -2px; }
        .rs-cell.on { background: #e6f5fc; box-shadow: inset 0 -3px 0 var(--sat-cyan); }
        .rs-cell .n { font-size: 1.35rem; font-weight: 700; line-height: 1.1; }
        .rs-cell .l { font-size: .8rem; color: var(--sat-muted); }
        .rs-cell.principal .n { font-size: 1.6rem; }
        .rs-cell.principal .l { font-weight: 700; color: var(--sat-ink); font-size: .85rem; }
        .rs-cell.open .n { color: var(--sat-open); }
        .rs-cell.closed .n { color: var(--sat-closed); }
        .rs-activo {
          display: flex; align-items: center; justify-content: space-between; gap: .75rem; flex-wrap: wrap;
          background: #e6f5fc; border: 1px solid #bfe6f6; color: #0d6c91; border-radius: 10px;
          padding: .5rem .9rem; font-size: .88rem; margin: -.25rem 0 1rem;
        }
        .rs-activo button {
          border: 0; background: transparent; color: #0d6c91; font-weight: 600; font-size: .85rem;
        }
        .rs-activo button:hover { text-decoration: underline; }

        /* ── Barra de herramientas ── */
        .ap-toolbar {
          display: flex; flex-wrap: wrap; gap: .75rem; align-items: center;
          justify-content: space-between; margin-bottom: .75rem;
        }
        .ap-seg {
          display: inline-flex; background: #fff; border: 1px solid var(--sat-line);
          border-radius: 10px; padding: 3px; gap: 2px; flex-wrap: wrap;
        }
        .ap-seg button {
          border: 0; background: transparent; color: var(--sat-muted);
          font-size: .86rem; font-weight: 600; padding: .4rem .85rem; border-radius: 7px;
        }
        .ap-seg button:hover { color: var(--sat-ink); }
        .ap-seg button.on { background: var(--sat-navy); color: #fff; }
        .ap-search { position: relative; flex: 0 1 320px; }
        .ap-search i { position: absolute; left: .8rem; top: 50%; transform: translateY(-50%); color: var(--sat-muted); font-size: .85rem; }
        .ap-search input {
          width: 100%; border: 1px solid var(--sat-line); border-radius: 10px;
          padding: .5rem .8rem .5rem 2.1rem; font-size: .9rem; background: #fff;
        }
        .ap-search input:focus { outline: none; border-color: var(--sat-cyan); box-shadow: 0 0 0 3px rgba(40,182,234,.18); }

        /* ── Tabla ── */
        .ap-table-wrap {
          background: #fff; border: 1px solid var(--sat-line); border-radius: 12px;
          overflow-x: auto;
        }
        .ap-table { width: 100%; min-width: 900px; border-collapse: separate; border-spacing: 0; }
        .ap-table thead th {
          position: sticky; top: 0; z-index: 1;
          background: var(--sat-bg); color: var(--sat-muted);
          font-size: .78rem; font-weight: 700; letter-spacing: .02em;
          padding: .7rem 1rem; border-bottom: 1px solid var(--sat-line); white-space: nowrap; text-align: left;
        }
        .ap-table tbody td {
          padding: .8rem 1rem; border-bottom: 1px solid var(--sat-line); vertical-align: middle; font-size: .9rem;
        }
        .ap-table tbody tr:last-child td { border-bottom: 0; }
        .ap-table tbody tr:hover td { background: #f7fbfd; }

        /* Barra lateral de estado: lo primero que se lee en cada fila */
        .ap-table td.estado-rail { padding: 0; width: 4px; }
        .estado-rail span { display: block; width: 4px; height: 100%; min-height: 58px; }
        .estado-rail .open { background: var(--sat-open); }
        .estado-rail .closed { background: var(--sat-closed); }
        .estado-rail .neutral { background: var(--sat-navy); }

        .cod { display: flex; flex-direction: column; gap: 4px; align-items: flex-start; }
        .cod-chip {
          font-family: 'Consolas', 'SFMono-Regular', Menlo, monospace; font-size: .84rem; font-weight: 700;
          padding: 2px 8px; border-radius: 6px; white-space: nowrap;
        }
        .cod-chip.sat  { background: #e4f5fc; color: #0d6c91; }
        .cod-chip.sen  { background: #fdf3e2; color: #9a5a00; }
        .cod-chip.sars { background: #e8eef7; color: var(--sat-navy); }
        .cod-chip.sara { background: #e5f3ea; color: var(--sat-sara); }
        .estado-txt { font-size: .76rem; font-weight: 600; }
        .estado-txt.open { color: var(--sat-open); }
        .estado-txt.closed { color: var(--sat-closed); }

        .evt-titulo {
          font-weight: 600; color: var(--sat-ink); max-width: 420px;
          display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
        }
        .evt-meta { font-size: .8rem; color: var(--sat-muted); margin-top: 2px; }

        .salas { display: flex; gap: 6px; flex-wrap: wrap; }
        .sala-btn {
          display: inline-flex; align-items: center; gap: 5px; position: relative;
          border: 1px dashed #c3ccd6; background: #fff; color: var(--sat-muted);
          border-radius: 8px; padding: 4px 9px; font-size: .78rem; font-weight: 700;
        }
        .sala-btn:hover { border-color: var(--sat-cyan); color: var(--sat-cyan-dark); }
        .sala-btn.is-activa { border-style: solid; border-color: var(--sat-cyan); background: var(--sat-cyan); color: #fff; }
        .sala-btn.is-activa:hover { background: var(--sat-cyan-dark); border-color: var(--sat-cyan-dark); color: #fff; }
        .sala-btn.sara.is-activa { background: var(--sat-sara); border-color: var(--sat-sara); }
        .sala-btn.sara.is-activa:hover { background: #246340; border-color: #246340; }
        .sala-btn.sara.is-activa .sala-count { color: var(--sat-sara); }
        .sala-count {
          background: #fff; color: var(--sat-cyan-dark); border-radius: 999px;
          font-size: .68rem; padding: 0 5px; line-height: 1.45;
        }

        .acciones { display: flex; gap: 2px; justify-content: flex-end; }
        .ic-btn {
          width: 32px; height: 32px; display: inline-grid; place-items: center;
          border: 0; border-radius: 8px; background: transparent; color: var(--sat-muted);
        }
        .ic-btn:hover:not(:disabled) { background: #eef4f8; color: var(--sat-navy); }
        .ic-btn.danger:hover:not(:disabled) { background: #fdecec; color: #c62828; }
        .ic-btn.cierre-on { color: var(--sat-closed); }
        .ic-btn:disabled { opacity: .3; cursor: not-allowed; }
        .acc-sep { width: 1px; background: var(--sat-line); margin: 6px 4px; }

        .ap-vacio { text-align: center; padding: 3rem 1rem; color: var(--sat-muted); }
        .ap-vacio i { font-size: 1.6rem; margin-bottom: .5rem; display: block; color: #b7c3cf; }

        .ap-foot {
          display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;
          gap: .75rem; margin-top: .9rem; font-size: .85rem; color: var(--sat-muted);
        }
        .ap-foot .pagination { margin: 0; }

        @media (max-width: 768px) {
          .alertas-page { padding: 1rem .25rem 1.5rem; }
          .ap-resumen { grid-template-columns: 1fr; }
          .ap-search { flex-basis: 100%; }
        }
        @media (prefers-reduced-motion: reduce) {
          .alertas-page * { transition: none !important; }
        }
      `}</style>

      {/* ── Encabezado ── */}
      <div className="ap-head">
        <div>
          <h2>Alertas y señales en salud</h2>
          <p className="ap-sub">{user ? `Bienvenido, ${user}` : 'No has iniciado sesión.'}</p>
        </div>
        <div className="ap-head-actions">
          <button className="ap-btn" onClick={() => navigate('/sala')}>
            <i className="fa-regular fa-calendar"></i> Agenda de salas
          </button>
          <button className="ap-btn" onClick={() => navigate('/showdirectorio')}>
            <i className="fa-regular fa-address-book"></i> Directorio
          </button>
          <button className="ap-btn" onClick={() => setShowChoosertabla(true)}>
            <i className="fa-solid fa-file-excel"></i> Exportar
          </button>
          <button className="ap-btn primary" onClick={() => setShowChooser(true)}>
            <i className="fas fa-plus"></i> Nuevo registro
          </button>
        </div>
      </div>

      {/* ── Resumen (filtrable por año; inicia en el año en curso) ── */}
      <div className="ap-resumen-head">
        <span>Resumen {anioResumen === 'todos' ? 'de todos los años' : `de ${anioResumen}`}</span>
        <select
          className="ap-anio"
          value={anioResumen}
          onChange={e => setAnioResumen(e.target.value === 'todos' ? 'todos' : parseInt(e.target.value, 10))}
          aria-label="Año del resumen"
        >
          {aniosDisponibles.map(y => <option key={y} value={y}>{y}</option>)}
          <option value="todos">Todos los años</option>
        </select>
      </div>
      <div className="ap-resumen">
        {[
          { tipo: 'SAT', nombre: 'Alertas' },
          { tipo: 'SEN', nombre: 'Señales' },
        ].map(({ tipo, nombre }) => {
          const r = resumen[tipo];
          const activo = (estado) =>
            filtroResumen && filtroResumen.tipo === tipo && filtroResumen.estado === estado;
          const celda = (estado, valor, etiqueta, clase = '') => (
            <button
              type="button"
              className={`rs-cell ${clase} ${activo(estado) ? 'on' : ''}`}
              onClick={() => filtrarDesdeResumen(tipo, estado)}
              aria-pressed={!!activo(estado)}
              title={`Ver ${etiqueta.toLowerCase()} en la tabla`}
            >
              <span className="n">{valor}</span>
              <span className="l">{etiqueta}</span>
            </button>
          );
          return (
            <div className={`rs-grupo ${tipo === 'SAT' ? 'g-sat' : 'g-sen'}`} key={tipo}>
              {celda(null, r.total, nombre, 'principal')}
              {celda('abiertas', r.abiertas, 'Abiertas', 'open')}
              {celda('cerradas', r.cerradas, 'Cerradas', 'closed')}
            </div>
          );
        })}
      </div>

      {filtroResumen && (
        <div className="rs-activo">
          <span>Mostrando <b>{descripcionFiltroResumen}</b></span>
          <button type="button" onClick={() => cambiarFiltro(null)}>
            <i className="fa-solid fa-xmark"></i> Quitar filtro
          </button>
        </div>
      )}

      {/* ── Filtros y búsqueda ── */}
      <div className="ap-toolbar">
        <div className="ap-seg" role="tablist" aria-label="Tipo de registro">
          {FILTROS.map(f => (
            <button
              key={f.label}
              role="tab"
              aria-selected={(filter || null) === f.key}
              className={(filter || null) === f.key ? 'on' : ''}
              onClick={() => cambiarFiltro(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>
        <div className="ap-search">
          <i className="fa-solid fa-magnifying-glass"></i>
          <input
            type="search"
            placeholder="Buscar por código, título o gestor"
            value={busqueda}
            onChange={e => onBuscar(e.target.value)}
            aria-label="Buscar registros"
          />
        </div>
      </div>

      {/* ── Modal: elegir tipo ── */}
      <Modal show={showChooser} onHide={() => setShowChooser(false)} centered>
        <Modal.Header closeButton><Modal.Title>¿Qué deseas ingresar?</Modal.Title></Modal.Header>
        <Modal.Body className="text-center">
          <Button className="btn_aleja me-3" onClick={() => onElegirTipo('SEN')}>Señal</Button>
          <Button className="btn_aleja me-3" onClick={() => onElegirTipo('SAT')}>Alerta</Button>
          <Button className="btn_aleja me-3" onClick={() => openSarModal('SARS')}><i>SARS-I</i></Button>
          <Button className="btn_aleja" onClick={() => openSarModal('SARA')} title="Sala de Análisis de Riesgo en Salud Ambiental"><i>SARA-I</i></Button>
        </Modal.Body>
      </Modal>

      {/* ── Modal: exportar tabla ── */}
      <Modal show={showChoosertabla} onHide={() => setShowChoosertabla(false)} centered>
        <Modal.Header closeButton><Modal.Title>¿Qué tabla desea exportar?</Modal.Title></Modal.Header>
        <Modal.Body className="text-center">
          <Button className="btn_aleja me-3" onClick={handletablaSAT}>SAT</Button>
          <Button className="btn_aleja me-3" onClick={handletablaSEN}>SEÑALES</Button>
          <Button className="btn_aleja me-3" onClick={handletablaSAR}>SARS</Button>
          <Button className="btn_aleja me-3" onClick={handletablaSARA}>SARA</Button>
        </Modal.Body>
      </Modal>

      {/* ── Modal: activar SAR ── */}
      <Modal show={showSarModal} onHide={() => setShowSarModal(false)} centered>
        <Modal.Header closeButton><Modal.Title>Activar Sala {sarTipo} {sarCodigo}</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="form-group mb-2">
            <label>Título: <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control"
              value={sarTitulo}
              onChange={e => setSarTitulo(e.target.value)}
              placeholder={sarTipo === 'SARA' ? 'Ej.: Calidad del agua en acueductos de Leticia' : 'Ej.: Situación de malaria en Puerto Nariño'}
              maxLength={200}
            />
            <small className="text-muted">Aparece en el asunto del correo de citación.</small>
          </div>
          <div className="form-group">
            <label>Fecha:</label>
            <input type="date" className="form-control" value={fechaCita} onChange={e => setFechaCita(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Hora Inicio:</label>
            <input type="time" className="form-control" value={horaCita} onChange={e => setHoraCita(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Hora Fin:</label>
            <input type="time" className="form-control" value={horaCitafin} onChange={e => setHoraCitafin(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Lugar:</label>
            <Select
              options={LUGAR_OPTIONS}
              value={lugar}
              onChange={selected => setlugar(selected)}
              placeholder="Seleccione o escriba un lugar"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          <div className="form-group">
            <label>Consecutivo de Correo:</label>
            <input type="text" className="form-control" value={correoConsecutivo} onChange={e => setCorreoConsecutivo(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Participantes:</label>
            <Select
              isMulti
              options={correos}
              value={participantesCita.map(e => ({ value: e, label: e }))}
              placeholder="Selecciona o escribe correos..."
              formatCreateLabel={input => `Agregar "${input}"`}
              onChange={selected => {
                if (!selected) { setParticipantesCita([]); return; }
                const lista = [...new Set(selected.map(s => s.value.trim()))];
                setParticipantesCita(lista);
              }}
              menuPortalTarget={document.body}
              styles={{
                menuPortal:      base         => ({ ...base, zIndex: 9999 }),
                option:          (base, state) => ({ ...base, color: esEmailValido(state.data.value) ? 'black' : 'red' }),
                multiValueLabel: (base, state) => ({ ...base, color: esEmailValido(state.data.value) ? 'black' : 'red' }),
              }}
            />
            <p className="mt-2">Correos seleccionados: <b>{participantesCita.length}</b></p>
          </div>
          <div className="form-group">
            <label>Tema a tratar:</label>
            <textarea className="form-control" value={tema} onChange={e => setTema(e.target.value)}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn_outline_aleja" onClick={() => setShowSarModal(false)}>Cancelar</Button>
          <Button className="btn_aleja"         onClick={handleCrearSar}>Guardar</Button>
        </Modal.Footer>
      </Modal>


      {/* ── Tabla ── */}
      <div className="ap-table-wrap">
        <table className="ap-table">
          <thead>
            <tr>
              <th aria-label="Estado"></th>
              <th>Código</th>
              <th>Evento</th>
              <th>Salas y ERI</th>
              <th style={{ textAlign: 'right' }}>Gestión</th>
            </tr>
          </thead>
          <tbody>
            {pagina.length === 0 && (
              <tr>
                <td colSpan="5">
                  <div className="ap-vacio">
                    <i className="fa-regular fa-folder-open"></i>
                    {busqueda
                      ? <>No hay registros que coincidan con “{busqueda}”.</>
                      : <>No hay registros en esta vista. Usa <b>Nuevo registro</b> para crear uno.</>}
                  </div>
                </td>
              </tr>
            )}

            {pagina.map(blog => {
              const tipo        = tipoCodigo(blog.Codigo);
              const citasSars   = esSalaIndependiente ? (filter === 'SAR' ? blog.citaciones : 0) : (sarsActivosMap.get(blog.Codigo) || 0);
              const citasSara   = esSalaIndependiente ? (filter === 'SARA' ? blog.citaciones : 0) : (sarasActivosMap.get(blog.Codigo) || 0);
              const tieneEri    = erisActivosSet.has(blog.Codigo);
              const estaCerrado = cierresSat.includes(blog.Codigo);
              const estadoClase = blog.isSar ? 'neutral' : estaCerrado ? 'closed' : 'open';

              return (
                <tr key={`${tipo.clase}-${blog.id}`}>
                  <td className="estado-rail"><span className={estadoClase}></span></td>

                  <td>
                    <div className="cod">
                      <span className={`cod-chip ${tipo.clase}`} title={tipo.nombre}>{blog.Codigo}</span>
                      {!blog.isSar && (
                        <span className={`estado-txt ${estaCerrado ? 'closed' : 'open'}`}>
                          {estaCerrado ? 'Cerrada' : 'Abierta'}
                        </span>
                      )}
                    </div>
                  </td>

                  <td>
                    <div className="evt-titulo" title={blog.Titulo}>{blog.Titulo || 'Sin título'}</div>
                    <div className="evt-meta">
                      {blog.Gestor || 'Sin gestor'}
                      {blog.Municipio ? `, ${blog.Municipio}` : ''}
                    </div>
                  </td>

                  <td>
                    <div className="salas">
                      {(!esSalaIndependiente || filter === 'SAR') && (
                        <SalaBtn activa={citasSars > 0} sigla="SARS" citas={citasSars} ruta={`/sars/${blog.Codigo}`} icono="fa-solid fa-people-group" />
                      )}
                      {(!esSalaIndependiente || filter === 'SARA') && (
                        <SalaBtn activa={citasSara > 0} sigla="SARA" citas={citasSara} ruta={`/sara/${blog.Codigo}`} icono="fa-solid fa-leaf" variante="sara" />
                      )}
                      <SalaBtn activa={tieneEri} sigla="ERI" ruta={`/Eri/${blog.Codigo}`} icono="fa-solid fa-triangle-exclamation" />
                    </div>
                  </td>

                  <td>
                    <div className="acciones">
                      {!blog.isSar && (
                        <>
                          <button className="ic-btn" onClick={() => navigate(`/view/${blog.id}`)} title="Ver detalle" aria-label="Ver detalle">
                            <i className="fas fa-eye"></i>
                          </button>
                          <button className="ic-btn" onClick={() => handleEdit(blog.id)} title="Editar" aria-label="Editar">
                            <i className="fas fa-pen"></i>
                          </button>
                          <button className="ic-btn" onClick={() => navigate(`/showact/${blog.Codigo}`)} title="Historial de actualizaciones" aria-label="Historial">
                            <i className="fas fa-clock-rotate-left"></i>
                          </button>
                          <button
                            className={`ic-btn ${estaCerrado ? 'cierre-on' : ''}`}
                            onClick={() => handleCerrar(blog.Codigo)}
                            title={estaCerrado ? 'Ver cierre' : 'Cerrar registro'}
                            aria-label={estaCerrado ? 'Ver cierre' : 'Cerrar registro'}
                          >
                            <i className={estaCerrado ? 'fa-solid fa-lock' : 'fa-solid fa-lock-open'}></i>
                          </button>
                        </>
                      )}
                      <button className="ic-btn" onClick={() => handleDownload(blog.Codigo)} title="Descargar carpeta (PDF)" aria-label="Descargar">
                        <i className="fa-solid fa-download"></i>
                      </button>
                      {!esSalaIndependiente && (
                        <>
                          <span className="acc-sep" aria-hidden="true"></span>
                          <button className="ic-btn danger" onClick={() => handleDeleteBlog(blog)} title="Eliminar" aria-label="Eliminar">
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ── Pie: conteo + paginación ── */}
      <div className="ap-foot">
        <span>
          {filtered.length
            ? `Mostrando ${desde}–${hasta} de ${filtered.length}`
            : 'Sin resultados'}
        </span>
        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={<i className="fas fa-chevron-left"></i>}
            nextLabel={<i className="fas fa-chevron-right"></i>}
            pageCount={pageCount}
            forcePage={Math.min(pageNumber, pageCount - 1)}
            onPageChange={handlePageChange}
            containerClassName="pagination"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            disabledClassName="disabled"
            activeClassName="active"
          />
        )}
      </div>
    </div>
  );
};

export default CompShowalertas;
